let storeRef = null;

export function setLoggerStore(store) {
	storeRef = store;
}

export function logError(message, error) {
	const traceId = storeRef?.getState()?.app?.traceId || 'unknown';
	console.error(`[traceId: ${traceId}]`, message, error);
}
